import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const Review1Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "Review1IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <circle cx="12.54" cy="12" r="10" fill="url(#paint0_linear_7623_98)" />
      <defs>
        <linearGradient
          id="paint0_linear_7623_98"
          x1="2.54004"
          y1="13.8478"
          x2="22.54"
          y2="13.8478"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Review1Icon;
